import PropTypes from 'prop-types';
import Select from 'react-select';
import { v4 as uuidv4 } from 'uuid';
import {
  Container,
  Icon,
  SelectHeader,
  StyledSelect,
  Select as SingleSelect,
} from './border-select-component-style';

/**
 * BorderSelect component.
 * @param {object} props - The component props.
 * @param {string} props.header - The select field header.
 * @param {string} props.name - The select field name.
 * @param {string} props.label - The select field label.
 * @param {string} props.value - The select field value.
 * @param {element} props.icon - The select field icon.
 * @param {Array} props.options - The select field options.
 * @param {Function} props.onChange - The select field onChange function.
 * @param {string} props.margin - The select field margin.
 * @param {boolean} props.isMulti - The select field isMulti.
 * @returns {JSX.Element} The rendered BorderSelect component.
 */
const BorderSelect = ({
  header,
  name,
  label,
  value,
  icon,
  options,
  onChange,
  margin,
  isMulti,
}) => (
  <Container margin={margin}>
    {header && <SelectHeader>{header}</SelectHeader>}
    {isMulti ? (
      <Select
        name={name}
        options={options}
        onChange={onChange}
        value={value}
        menuPosition="fixed"
        isMulti
      />
    ) : (
      <SingleSelect>
        <StyledSelect
          name={name}
          label={label}
          placeholder={label}
          value={value}
          onChange={onChange}
          indent={icon ? '30px' : '0'}
        >
          {label ? <option value="">{label}</option> : null}
          {options.map((option) => (
            <option
              value={typeof option !== 'string' ? option.value : option}
              key={uuidv4()}
            >
              {typeof option !== 'string' ? option.text : option}
            </option>
          ))}
        </StyledSelect>
        {icon ? <Icon>{icon}</Icon> : null}
      </SingleSelect>
    )}
  </Container>
);

BorderSelect.defaultProps = {
  header: '',
  name: '',
  label: '',
  icon: undefined,
  onChange: undefined,
  margin: undefined,
  isMulti: false,
};

BorderSelect.propTypes = {
  // Select field header
  header: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  icon: PropTypes.element,
  // error object
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ).isRequired,
  onChange: PropTypes.func,
  margin: PropTypes.string,
  isMulti: PropTypes.bool,
};

export default BorderSelect;
